import { Component } from '@angular/core';
import { HtmlClassService } from '../../html-class.service';

@Component({
  selector: 'kt-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  constructor(private htmlService: HtmlClassService) {}

  toggle_maximize() {
    this.htmlService.toggleFullscreen();
    return false;
  }
}
